<template>
  <div v-if="stockOrdersOut && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="stockOrdersOut"
    />
  </div>
</template>
<script>
import StockOuts from "@/api/stock_out_orders";

import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";
import makeData from "./makeData";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    stockOrdersOut: [],
  }),

  mounted() {
    PrintTemplates.fetchOne("shopInventoryStockOrderOut").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.print_template.template;
          this.formater = formater;

          //获取单据详情
          StockOuts.fetch(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stockOrdersOut = response.data.stock_outs;
                if (this.stockOrdersOut)
                  this.stockOrdersOut = this.stockOrdersOut.map(
                    (stockOrderOut) => {
                      return makeData.processDetails(stockOrderOut);
                    }
                  );
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>